<template>
    <div class="column is-6 is-4-desktop">
        <router-link
            :to="{
                name: 'leasehold-property',
                params: { id: property.PropertyPK }
            }"
        >
            <div class="card card-clickable">
                <div class="card-content">
                    <article class="media">
                        <figure class="media-left">
                            <div class="image-wrapper">
                                <img
                                    v-lazy="`/contacts/leaseholder/properties/${property.PropertyPK}/photos/first?w=150`"
                                    :alt="property.AddressString"
                                />
                            </div>
                        </figure>
                        <div class="media-content">
                            <div class="content">
                                <p class="title is-5">
                                    {{ property.AddressString }}
                                </p>
                                <b-taglist
                                    v-if="property.PropertyStatus"
                                    attached
                                >
                                    <b-tag type="is-dark">
                                        Status
                                    </b-tag>
                                    <b-tag>
                                        {{ property.PropertyStatus }}
                                    </b-tag>
                                </b-taglist>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
export default {
    props: {
        property: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss">
    .title a
    {
        color: #363636;

        &:hover
        {
            color: #3273DC;
        }
    }
</style>
